<script>
import { zendeskActions, zendeskValidateActions } from '@state/helpers'
import SubHeader from '@components/sub-header'
import { mapGetters } from 'vuex'

export default {
  name: 'Input',
  components: {
    SubHeader,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
    toHide: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  data() {
    return {
      inputContent: '',
    }
  },
  computed: {
    ...mapGetters('widgets', ['notSatisfiedUser', 'widgetProperty']),
    getDataType() {
      return this.componentData.dataType
        ? this.componentData.dataType
        : 'String'
    },
    show () {
      return this.widgetProperty(this.componentData.customFieldId, 'show')
    }
  },
  watch: {
    inputContent() {
      const { maxlength } = this.componentData
      if (maxlength && this.inputContent.length >= maxlength)
        this.$toasted.show(
          `${this.$t('WIDGETS.INPUT.MAX_LENGTH')} (${maxlength})`,
          {
            theme: 'bubble',
            position: 'top-center',
            duration: 3000,
          }
        )
      this.commitCustomField({
        value: this.changeDataType(this.inputContent),
        // id: this.componentData.customFieldId,
        key: this.componentData.name,
      })

      if (this.inputContent.length > 0) {
        this.commitValidatedField({
          type: 'customField',
          key: this.componentData.name,
          name,
          message: this.$t('COMMON.REQUIRED_INPUT'),
        })
      } else if (this.inputContent.length === 0) {
        this.removeValidatedField({ key: this.componentData.name })
      }
    },
  },
  created() {
    this.validateIfRequired()
  },
  methods: {
    ...zendeskActions,
    ...zendeskValidateActions,
    validateIfRequired() {
      const { name } = this.$options

      if (this.componentData.required) {
        this.commitRequiredFields({
          type: 'customField',
          key: this.componentData.name,
          name,
          message: this.$t('COMMON.REQUIRED_INPUT'),
        })
      }
    },
    changeDataType(dataTypeToChange) {
      if (this.getDataType === 'number') {
        return parseInt(dataTypeToChange, 10)
      }
      return dataTypeToChange
    },
  },
}
</script>

<template>
  <div
    v-if="notSatisfiedUser && show"
    :class="$style.container">
    <SubHeader
      :class="$style.container__header"
      :text="componentData.additionalData.title"
    />

    <div :class="$style.container__center">
      <BaseInput
        v-model="inputContent"
        :type="componentData.type"
        :name="componentData.name"
        :placeholder="componentData.placeHolder"
        :base="true"
        :only-numbers="componentData.additionalData.onlyNumbers"
        :maxlength="componentData.maxlength"
      />
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  padding: $size-spacing-medium 0;
  margin: 0;
  background-color: $background-container;

  &__header {
    padding-bottom: 1rem;
  }

  h4 {
    margin: 0 0.5rem 1rem 1rem;
    text-align: left;
  }

  &__center {
    text-align: center;
  }
}
</style>
